import React from 'react';
import {
  FeaturesMegaMenuLinksContainer,
  FeaturesMegaMenuLink,
  FeaturesMegaMenuLinksContent,
  FeaturesMegaMenuLinksContainerProps,
} from './FeaturesMegaMenuLinks.styles';
import FeaturesMegaMenuLinksData from './FeaturesMegaMenuLinksData';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import LinkBrandedLarge from 'src/molecules/Standard/Shared/2024_Q3_profit_sales_redesign/LinkBrandedLarge/LinkBrandedLarge';

const FeaturesMegaMenuLinks = ({ isFullWidth = false }: FeaturesMegaMenuLinksContainerProps): JSX.Element => (
  <FeaturesMegaMenuLinksContainer isFullWidth={isFullWidth}>
    <Paragraph
      standardSize='0.75'
      letterSpacing={1}
      text='FEATURES'
      align='left'
      weight={600}
      className='feature-links-section-title'
      color={palette.darkSilver}
    />
    <FeaturesMegaMenuLinksContent>
      {FeaturesMegaMenuLinksData.map((link, index) => (
        <FeaturesMegaMenuLink
          key={index}
          to={link.href}
        >
          <Paragraph
            standardSize='1'
            weight={700}
            text={link.title}
            className='link-title'
          />
          <Paragraph
            standardSize='0.75'
            weight={400}
            text={link.subtitle}
            className='link-subtitle'
          />
        </FeaturesMegaMenuLink>
      ))}
    </FeaturesMegaMenuLinksContent>
    <LinkBrandedLarge
      url='/features'
      className='view-all-features'
      text='View All Features'
      colorScheme='Wheat'
      customBorderColor={palette.lightWheat}
    />
  </FeaturesMegaMenuLinksContainer>
);

export default FeaturesMegaMenuLinks;
